import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Select from '@root/core/src/components/select';

export default function GenderSelect({
  dropdownIndicator,
  dropdownIndicatorColor,
  onChange,
  options,
  optionStyles,
  persistLabel = false,
  selectBoxFocusedStyles,
  selectBoxStyles,
  selectedValue,
}) {
  const mappedOptions = options.map(([value, label]) => ({
    value,
    label,
  }));

  return (
    <Select
      autoComplete={'gender-level1'}
      dropdownIndicator={dropdownIndicator}
      dropdownIndicatorColor={dropdownIndicatorColor}
      inputId={'gender-level1'}
      inputName={'gender-level1'}
      onChange={onChange}
      options={mappedOptions}
      optionStyles={optionStyles}
      persistLabel={persistLabel}
      placeholder={'Gender'}
      selectBoxFocusedStyles={selectBoxFocusedStyles}
      selectBoxStyles={selectBoxStyles}
      selectedValue={selectedValue}
    />
  );
}

GenderSelect.propTypes = {
  dropdownIndicator: PropTypes.string,
  dropdownIndicatorColor: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  optionStyles: PropTypes.object,
  persistLabel: PropTypes.bool,
  selectBoxFocusedStyles: PropTypes.object,
  selectBoxStyles: PropTypes.object,
  selectedValue: PropTypes.string.isRequired,
};
